/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PurchaseSubmitRequest interface.
 */
export function instanceOfPurchaseSubmitRequest(value) {
    return true;
}
export function PurchaseSubmitRequestFromJSON(json) {
    return PurchaseSubmitRequestFromJSONTyped(json, false);
}
export function PurchaseSubmitRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'rateId': json['rateId'] == null ? undefined : json['rateId'],
    };
}
export function PurchaseSubmitRequestToJSON(json) {
    return PurchaseSubmitRequestToJSONTyped(json, false);
}
export function PurchaseSubmitRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'rateId': value['rateId'],
    };
}
